// extracted by mini-css-extract-plugin
export default {"stats":"Card_stats__FgVLR","card":"Card_card__FcttR","category":"Card_category__Kpqtb","content":"Card_content__HrKfg"};